import { gql } from "lib/apolloClient";

export const createMultiLevelNodesDraftMutation = gql`
  mutation createMultiLevelNodesDraft(
    $subjectId: ID
    $nodeType: MULTI_LEVEL_NODE_TYPE!
    $rootNodes: [ID!]
    $nodes: [JSON!] = []
    $parentId: ID
    $parentType: NODE_DRAFT_PARENT_TYPE_ENUM
  ) {
    organizationManagement {
      createMultiLevelNodesDraft(
        input: {
          subjectId: $subjectId
          type: $nodeType
          rootNodes: $rootNodes
          nodes: $nodes
          parentId: $parentId
          parentType: $parentType
        }
      ) {
        draft {
          id
        }
      }
    }
  }
`;

export const deleteMultiLevelNodesDraftMutation = gql`
  mutation deleteMultiLevelNodesDraft($draftId: ID) {
    organizationManagement {
      deleteMultiLevelNodesDraft(input: { id: $draftId }) {
        isSuccess
        warning
      }
    }
  }
`;

export const updateMultiLevelNodesDraftMutation = gql`
  mutation updateMultiLevelNodes(
    $draftId: ID!
    $rootNodes: [ID!] = []
    $removedNodes: [ID!] = []
    $updatedNodes: [JSON!] = []
  ) {
    organizationManagement {
      updateMultiLevelNodesDraft(
        input: {
          id: $draftId
          rootNodes: $rootNodes
          removedNodes: $removedNodes
          updatedNodes: $updatedNodes
        }
      )
    }
  }
`;

export const publishMultiLevelNodeDraftMutation = gql`
  mutation publishMultiLevelNodeDraft($draftId: ID!, $plannerElementSetId: ID) {
    planner {
      publishMultiLevelNodeDraft(
        draftId: $draftId
        plannerElementSetId: $plannerElementSetId
      )
    }
  }
`;

export const createMultiLevelTagsMutation = gql`
  mutation createMultiLevelTags($input: [GenericTagInsertInput!]!) {
    platform {
      insertGenericTagsV2(input: $input) {
        id
        label
        icon {
          id
          url
        }
        displaySequence
      }
    }
  }
`;

export const reorderMultiLevelTagsMutation = gql`
  mutation reorder($id: ID!, $putAfterItemId: ID) {
    platform {
      reorderGenericTags(input: { id: $id, putAfterItemId: $putAfterItemId })
      __typename
    }
  }
`;

export const updateMultiLevelTagLabelMutation = gql`
  mutation updateGenericTags($input: UpdateGenericTagInput!) {
    platform {
      updateGenericTags(input: $input) {
        id
        label
        __typename
      }
      __typename
    }
  }
`;

export const deleteMultiLevelTagMutation = gql`
  mutation deleteMultiLevelTags($input: DeleteIdsInput!) {
    platform {
      deleteGenericTags(input: $input)
      __typename
    }
  }
`;
